import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";

import {
  Stack,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormLabel,
  FormControlLabel,
  Switch,
  Tooltip,
  Button,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  ToggleButton,
  Autocomplete,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { PreLoader } from "../../subcomponents/Preloader";
import { textStyle } from "../../styles/Style";
import "../../../components/styles/popupStyle.css";
import { phoneTypes } from "../../../constants/PhoneTypes";
import { Languages } from "../../../constants/languages";
import GooglePlacesAutocomplete, {
  Place,
} from "../../subcomponents/GoogleAutocomplete";
import {
  validateEmail,
  validatePhoneNumber,
  validationMessages,
  validationLength,
  validateVendorCodeField,
  validateVendorNameField,
  validateOptionalTextFieldWithMinLength,
  validationType,
  MIN_TEXT_FIELD_LENGTH,
} from "../../actions/validations";
import {
  converttoDayjsTime,
  converttoStandardTime,
  propertyTime,
} from "../../../constants/PropertyInformation";
import { TutorialComponent } from "../../Tour/DemoTour";
import { RoomPropertyEnum } from "../../../constants/NavbarList";
import { YesOrNo } from "../../../constants/YesOrNo";
import { GolfPropertyTime } from "../../../constants/PropertyInformation";
import { tooltipComponent } from "../../subcomponents/tooltipComponent";
import InfoIcon from "@mui/icons-material/Info";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { DAYS } from "../../../constants/Days";
import { ArrowDropDownIcon } from "@mui/x-date-pickers/icons";
import DraggableItemList from "../../subcomponents/DNDComponent";
import { buttonValues, DNDFieldsEnum } from "../../../constants/Types";
import {
  checkData,
  deleteItem,
  fillAutocompleteValues,
  updateData,
} from "../../actions/actionItems";
import { GolfPropertyEnum } from "../../../constants/NavbarList";
import AlertComponent from "../../subcomponents/AlertComponent";
import {
  golfTooltipHeaders,
  originsTooltip,
} from "../../../constants/TooltipInformation";
import { removeSampleTestArray } from "../../actions/cleanup";
import { ClearButton } from "../../subcomponents/ClearButton";
import { CopyButton } from "../../subcomponents/CopyButton";
import { PercentageorFlatAmount } from "../../../constants/GuaranteeField";
import {
  DEFAULT_VENDOR_MAIL_CONTACT_TYPE,
  DEFAULT_VENDOR_PHONE_CONTACT_TYPE,
  isMailVendorContactType,
  isPhoneVendorContactType,
  parseVendorBooleanField,
  VENDOR_MAIL_CONTACT_TYPES,
  VENDOR_PHONE_CONTACT_TYPES,
  vendorBooleanToExcel,
} from "../../../constants/VendorContactTypes";
import { normalizeVendorSetupPayload } from "../../../excel/mapping/vendorSetupRows";

const resetContactFields = (
  setIsPrimary: (value: boolean) => void,
  setIsPrivateInfo: (value: boolean) => void,
  setEmailContactType: (value: string) => void,
  setEmailValue: (value: string | null) => void,
  setPhoneContactType: (value: string) => void,
  setPhoneValue: (value: string | null) => void,
  setEmailValueError: (value: boolean) => void,
  setEmailValueErrorMessage: (value: string) => void,
  setPhoneValueError: (value: boolean) => void,
  setPhoneValueErrorMessage: (value: string) => void,
) => {
  setIsPrimary(true);
  setIsPrivateInfo(false);
  setEmailContactType(DEFAULT_VENDOR_MAIL_CONTACT_TYPE);
  setEmailValue(null);
  setPhoneContactType(DEFAULT_VENDOR_PHONE_CONTACT_TYPE);
  setPhoneValue(null);
  setEmailValueError(false);
  setEmailValueErrorMessage("");
  setPhoneValueError(false);
  setPhoneValueErrorMessage("");
};

const VendorSetup = ({
  data,
  fieldValues,
}: {
  data: any;
  fieldValues: any;
}) => {
  const [vendorType, setVendorType] = useState<string | null>(null);
  const [vendorCode, setVendorCode] = useState<string | null>(null);
  const [firstName, setFirstName] = useState<string | null>(null);
  const [lastName, setLastName] = useState<string | null>(null);
  const [address, setAddress] = useState<string | null>(null);
  const [city, setCity] = useState<string | null>(null);
  const [state, setState] = useState<string | null>(null);
  const [country, setCountry] = useState<string | null>(null);
  const [postalCode, setPostalCode] = useState<string | null>(null);
  const [isPrimary, setIsPrimary] = useState<boolean>(true);
  const [isPrivateInfo, setIsPrivateInfo] = useState<boolean>(false);
  const [emailContactType, setEmailContactType] = useState<string>(
    DEFAULT_VENDOR_MAIL_CONTACT_TYPE,
  );
  const [emailValue, setEmailValue] = useState<string | null>(null);
  const [phoneContactType, setPhoneContactType] = useState<string>(
    DEFAULT_VENDOR_PHONE_CONTACT_TYPE,
  );
  const [phoneValue, setPhoneValue] = useState<string | null>(null);
  const [vendorName, setVendorName] = useState<string | null>(null);
  const [comments, setComments] = useState<string | null>(null);
  const [defaultt, setDefault] = useState<boolean>(false);
  const [editClicked, setEditClicked] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [lastUpdatedRecord, setLastUpdatedRecord] = useState<any>(null);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const [GoldVendorSetup, setGoldVendorSetup] = useState<any>([]);
  const [vendorTypeList, setVendorTypeList] = useState<string[]>([]);
  const [vendorCodeError, setVendorCodeError] = useState<boolean>(false);
  const [vendorCodeErrorMessage, setVendorCodeErrorMessage] =
    useState<string>("");
  const [vendorNameError, setVendorNameError] = useState<boolean>(false);
  const [vendorNameErrorMessage, setVendorNameErrorMessage] =
    useState<string>("");
  const [firstNameError, setFirstNameError] = useState<boolean>(false);
  const [firstNameErrorMessage, setFirstNameErrorMessage] =
    useState<string>("");
  const [lastNameError, setLastNameError] = useState<boolean>(false);
  const [lastNameErrorMessage, setLastNameErrorMessage] = useState<string>("");
  const [emailValueError, setEmailValueError] = useState<boolean>(false);
  const [emailValueErrorMessage, setEmailValueErrorMessage] =
    useState<string>("");
  const [phoneValueError, setPhoneValueError] = useState<boolean>(false);
  const [phoneValueErrorMessage, setPhoneValueErrorMessage] =
    useState<string>("");

  useEffect(() => {
    if (fieldValues) {
      setGoldVendorSetup(
        normalizeVendorSetupPayload(
          fieldValues[GolfPropertyEnum.vendorSetup] || [],
        ),
      );
      setVendorTypeList(
        fillAutocompleteValues(
          fieldValues[GolfPropertyEnum.vendorTypes],
          DNDFieldsEnum.VENDORTYPE,
          "",
        ),
      );
    }
  }, []);
  const validateVendorSetupInput = (): boolean => {
    if (!vendorCode || !vendorName) {
      setAlertMessage("Vendor Code and Vendor Name are mandatory");
      setAlertType("error");
      setOpenAlert(true);
      return false;
    }

    setVendorCodeError(false);
    setVendorCodeErrorMessage("");
    setVendorNameError(false);
    setVendorNameErrorMessage("");
    setFirstNameError(false);
    setFirstNameErrorMessage("");
    setLastNameError(false);
    setLastNameErrorMessage("");

    if (String(vendorCode).trim().length < MIN_TEXT_FIELD_LENGTH) {
      setVendorCodeError(true);
      setVendorCodeErrorMessage(validationMessages.vendorCodeMinLength);
      return false;
    }
    if (!validateVendorCodeField(vendorCode)) {
      setVendorCodeError(true);
      setVendorCodeErrorMessage(validationMessages.vendorCode);
      return false;
    }

    if (String(vendorName).trim().length < MIN_TEXT_FIELD_LENGTH) {
      setVendorNameError(true);
      setVendorNameErrorMessage(validationMessages.vendorNameMinLength);
      return false;
    }
    if (!validateVendorNameField(vendorName)) {
      setVendorNameError(true);
      setVendorNameErrorMessage(validationMessages.vendorName);
      return false;
    }

    if (
      firstName &&
      String(firstName).trim().length > 0 &&
      String(firstName).trim().length < MIN_TEXT_FIELD_LENGTH
    ) {
      setFirstNameError(true);
      setFirstNameErrorMessage(validationMessages.firstNameMinLength);
      return false;
    }
    if (
      !validateOptionalTextFieldWithMinLength(
        firstName,
        validationLength.firstName,
        validationType.SPACE,
      )
    ) {
      setFirstNameError(true);
      setFirstNameErrorMessage(validationMessages.firstName);
      return false;
    }

    if (
      lastName &&
      String(lastName).trim().length > 0 &&
      String(lastName).trim().length < MIN_TEXT_FIELD_LENGTH
    ) {
      setLastNameError(true);
      setLastNameErrorMessage(validationMessages.lastNameMinLength);
      return false;
    }
    if (
      !validateOptionalTextFieldWithMinLength(
        lastName,
        validationLength.lastName,
        validationType.SPACE,
      )
    ) {
      setLastNameError(true);
      setLastNameErrorMessage(validationMessages.lastName);
      return false;
    }

    setEmailValueError(false);
    setEmailValueErrorMessage("");
    setPhoneValueError(false);
    setPhoneValueErrorMessage("");

    const trimmedEmail = emailValue?.trim() ?? "";
    const trimmedPhone = phoneValue?.trim() ?? "";

    if (trimmedEmail && !validateEmail(trimmedEmail)) {
      setEmailValueError(true);
      setEmailValueErrorMessage(validationMessages.email);
      return false;
    }

    if (trimmedPhone && !validatePhoneNumber(trimmedPhone)) {
      setPhoneValueError(true);
      setPhoneValueErrorMessage(validationMessages.phoneNumber);
      return false;
    }

    return true;
  };

  const buildVendorBaseFields = () => ({
    "Vendor Code": vendorCode,
    "Vendor Name": vendorName,
    "Vendor Type": vendorType,
    "First Name": firstName,
    "Last Name": lastName,
    Address: address,
    City: city,
    State: state,
    Country: country,
    "Postal Code": postalCode,
    Comments: comments,
    "Is Primary": vendorBooleanToExcel(isPrimary),
    "Is Private Info": vendorBooleanToExcel(isPrivateInfo),
  });

  const buildVendorContacts = () => {
    const contacts: Record<string, unknown>[] = [];
    const trimmedEmail = emailValue?.trim() ?? "";
    const trimmedPhone = phoneValue?.trim() ?? "";

    if (trimmedEmail) {
      contacts.push({
        "Contact Type": emailContactType,
        Value: trimmedEmail,
      });
    }

    if (trimmedPhone) {
      contacts.push({
        "Contact Type": phoneContactType,
        Value: trimmedPhone,
      });
    }

    return contacts;
  };

  const buildVendorRecord = () => ({
    ...buildVendorBaseFields(),
    contacts: buildVendorContacts(),
  });

  const getNextVendorId = (existingItems: any[]) =>
    Math.max(0, ...existingItems.map((item: any) => Number(item?.id) || 0)) + 1;

  const applyVendorContacts = (vendor: any) => {
    setEmailContactType(DEFAULT_VENDOR_MAIL_CONTACT_TYPE);
    setEmailValue(null);
    setPhoneContactType(DEFAULT_VENDOR_PHONE_CONTACT_TYPE);
    setPhoneValue(null);

    const contacts = Array.isArray(vendor?.contacts)
      ? vendor.contacts
      : vendor?.["Contact Type"]
        ? [vendor]
        : [];

    contacts.forEach((record: any) => {
      const type = record?.["Contact Type"];
      const value = record?.Value ?? record?.Email ?? record?.Mobile ?? null;

      if (isMailVendorContactType(type) && value) {
        setEmailContactType(type);
        setEmailValue(String(value));
      } else if (isPhoneVendorContactType(type) && value) {
        setPhoneContactType(type);
        setPhoneValue(String(value));
      }
    });

    setIsPrimary(parseVendorBooleanField(vendor?.["Is Primary"], true));
    setIsPrivateInfo(
      parseVendorBooleanField(vendor?.["Is Private Info"], false),
    );
  };

  const updateGoldVendorSetup = () => {
    if (!validateVendorSetupInput()) {
      return false;
    }
    setGoldVendorSetup((prev: any) => {
      const current = prev ?? [];
      const updatedRecord = {
        id: selectedId,
        ...buildVendorRecord(),
      };
      return updateData(
        current.map((item: any) =>
          item.id === selectedId ? updatedRecord : item,
        ),
      );
    });
    editGoldVendorSetup(null);
    setEditClicked(false);
    setSelectedId(null);
    setAlertMessage(`${GolfPropertyEnum.vendorSetup} updated successfully`);
    setAlertType("success");
    setOpenAlert(true);
  };

  const addGoldVendorSetup = () => {
    if (!validateVendorSetupInput()) {
      return false;
    }
    const vendorRecord = buildVendorRecord();
    setGoldVendorSetup((prev: any) => {
      const current = prev ?? [];
      const newRecord = {
        id: getNextVendorId(current),
        ...vendorRecord,
      };
      return updateData([...current, newRecord]);
    });
    setLastUpdatedRecord(vendorRecord);
    editGoldVendorSetup(null);
    setEditClicked(false);
  };

  const editGoldVendorSetup = (list: any) => {
    list?.id && setSelectedId(list.id);
    list !== null && setEditClicked(true);

    if (!list) {
      setVendorCode(null);
      setVendorName(null);
      setVendorType(null);
      setFirstName(null);
      setLastName(null);
      setAddress(null);
      setCity(null);
      setState(null);
      setCountry(null);
      setPostalCode(null);
      setComments(null);
      resetContactFields(
        setIsPrimary,
        setIsPrivateInfo,
        setEmailContactType,
        setEmailValue,
        setPhoneContactType,
        setPhoneValue,
        setEmailValueError,
        setEmailValueErrorMessage,
        setPhoneValueError,
        setPhoneValueErrorMessage,
      );
      setVendorCodeError(false);
      setVendorCodeErrorMessage("");
      setVendorNameError(false);
      setVendorNameErrorMessage("");
      setFirstNameError(false);
      setFirstNameErrorMessage("");
      setLastNameError(false);
      setLastNameErrorMessage("");
      return;
    }

    setVendorCode(list?.["Vendor Code"]);
    setVendorName(list?.["Vendor Name"]);
    setVendorType(list?.["Vendor Type"]);
    setFirstName(list?.["First Name"]);
    setLastName(list?.["Last Name"]);
    setAddress(list?.["Address"]);
    setCity(list?.["City"]);
    setState(list?.["State"]);
    setCountry(list?.["Country"]);
    setPostalCode(list?.["Postal Code"]);
    setComments(list?.["Comments"]);
    setVendorCodeError(false);
    setVendorCodeErrorMessage("");
    setVendorNameError(false);
    setVendorNameErrorMessage("");
    setFirstNameError(false);
    setFirstNameErrorMessage("");
    setLastNameError(false);
    setLastNameErrorMessage("");
    setEmailValueError(false);
    setEmailValueErrorMessage("");
    setPhoneValueError(false);
    setPhoneValueErrorMessage("");

    applyVendorContacts(list);
  };

  const deleteGoldVendorSetup = (id: number) => {
    setGoldVendorSetup(deleteItem(GoldVendorSetup, id));
  };

  useEffect(() => {
    data(GoldVendorSetup);
    editClicked &&
      setSelectedId(checkData(GoldVendorSetup, selectedId) ? selectedId : null);
  }, [GoldVendorSetup]);

  const updateAddress = (addressComponents: any) => {
    let addressLine1 = "";
    let addressLine2 = "";
    let city = "";
    let state = "";
    let country = "";
    let zipCode = "";

    addressComponents.forEach((component: any) => {
      const primaryType = component.types[0];

      switch (primaryType) {
        case "street_number":
          addressLine1 = component.long_name + " " + addressLine1;
          break;
        case "route":
          addressLine1 = addressLine1 + component.long_name;
          break;
        case "sublocality":
        case "sublocality_level_1":
          addressLine1 = addressLine1 + component.long_name;
          break;
        case "neighborhood":
          addressLine1 = addressLine1 + component.long_name;
          break;
        case "subpremise":
          addressLine1 = addressLine1 + component.long_name;
          break;
        case "locality":
          city = component.long_name;
          break;
        case "administrative_area_level_1":
          state = component.long_name;
          break;
        case "country":
          country = component.long_name;
          break;
        case "postal_code":
          zipCode = component.long_name;
          break;
      }
    });
    setAddress(addressLine1.trim());
    if (addressLine2) setAddress(addressLine2.trim());
    if (city) setCity(city);
    if (state) setState(state);
    if (country) setCountry(country);
    if (zipCode) setPostalCode(zipCode);
  };
  return (
    <Stack>
      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          padding: "20px",
        }}
      >
        <Stack direction="row" width="100%" justifyContent="space-between">
          <Typography variant="h6" component="div" sx={textStyle}>
            Vendor Setup
            <Tooltip
              title={tooltipComponent(golfTooltipHeaders.vendorSetupHeader)}
            >
              <InfoIcon fontSize="small" />
            </Tooltip>
          </Typography>
          <Stack direction="row" gap="10px" justifyContent="space-between">
            {editClicked && (
              <ClearButton
                click={() => {
                  editGoldVendorSetup(null);
                  setSelectedId(null);
                }}
              />
            )}
            {lastUpdatedRecord && (
              <CopyButton
                click={() => {
                  editGoldVendorSetup(lastUpdatedRecord);
                }}
              />
            )}
          </Stack>
        </Stack>
        <FormLabel component="legend">
          Vendor Type
          <Tooltip
            title={tooltipComponent(golfTooltipHeaders.percentageOrFlatAmount)}
          >
            <InfoIcon fontSize="small" />
          </Tooltip>
        </FormLabel>
        <Stack direction="row" width="100%" gap="5px">
          <Autocomplete
            id="vendorType"
            disablePortal
            options={removeSampleTestArray(vendorTypeList)}
            sx={{ width: "100%" }}
            value={vendorType?.toString() ?? ""}
            disabled={!vendorTypeList}
            onChange={(e: any) => setVendorType(e.target.innerText)}
            renderInput={(params) => (
              <TextField {...params} label="Vendor Type" />
            )}
          />
          <Tooltip title={tooltipComponent(golfTooltipHeaders.vendorTypes)}>
            <InfoIcon fontSize="small" />
          </Tooltip>
        </Stack>
        <FormLabel component="legend">
          Vendor Code
          <Tooltip title={tooltipComponent(golfTooltipHeaders.minMinutes)}>
            <InfoIcon fontSize="small" />
          </Tooltip>
        </FormLabel>
        <TextField
          id="vendorcode"
          variant="outlined"
          placeholder="Vendor Code"
          value={vendorCode ?? ""}
          onChange={(e: any) => {
            setVendorCode(e.target.value);
            setVendorCodeError(false);
            setVendorCodeErrorMessage("");
          }}
          error={vendorCodeError}
          helperText={vendorCodeError ? vendorCodeErrorMessage : ""}
        />
        <FormLabel component="legend">
          Vendor Name
          <Tooltip title={tooltipComponent(golfTooltipHeaders.minMinutes)}>
            <InfoIcon fontSize="small" />
          </Tooltip>
        </FormLabel>
        <TextField
          id="vendorname"
          variant="outlined"
          placeholder="Vendor Name"
          value={vendorName ?? ""}
          onChange={(e: any) => {
            setVendorName(e.target.value);
            setVendorNameError(false);
            setVendorNameErrorMessage("");
          }}
          error={vendorNameError}
          helperText={vendorNameError ? vendorNameErrorMessage : ""}
        />
        {/* <Select>
                    VENDOR REPRESENTATIVE
                </Select> */}
        <FormLabel component="legend">
          First Name
          <Tooltip title={tooltipComponent(golfTooltipHeaders.minMinutes)}>
            <InfoIcon fontSize="small" />
          </Tooltip>
        </FormLabel>
        <TextField
          id="firstname"
          variant="outlined"
          placeholder="First Name"
          value={firstName ?? ""}
          onChange={(e: any) => {
            setFirstName(e.target.value);
            setFirstNameError(false);
            setFirstNameErrorMessage("");
          }}
          error={firstNameError}
          helperText={firstNameError ? firstNameErrorMessage : ""}
        />
        <FormLabel component="legend">
          Last Name
          <Tooltip title={tooltipComponent(golfTooltipHeaders.minMinutes)}>
            <InfoIcon fontSize="small" />
          </Tooltip>
        </FormLabel>
        <TextField
          id="lastname"
          variant="outlined"
          placeholder="Last Name"
          value={lastName ?? ""}
          onChange={(e: any) => {
            setLastName(e.target.value);
            setLastNameError(false);
            setLastNameErrorMessage("");
          }}
          error={lastNameError}
          helperText={lastNameError ? lastNameErrorMessage : ""}
        />
        <FormLabel component="legend">Address</FormLabel>
        <GooglePlacesAutocomplete
          apiKey={process.env.REACT_APP_GOOGLE_API_KEY ?? ""}
          onPlaceSelected={(data: Place) => {
            updateAddress(data.addressComponents);
          }}
        />
        <TextField
          id="addressLine1"
          variant="outlined"
          placeholder="Address Line 1"
          value={address ?? ""}
          onChange={(e: any) => {
            setAddress(e.target.value);
          }}
        />
        <TextField
          id="city"
          variant="outlined"
          placeholder="City"
          value={state ?? ""}
          onChange={(e: any) => {
            setState(e.target.value);
          }}
        />
        <TextField
          id="state"
          variant="outlined"
          placeholder="State"
          value={country ?? ""}
          onChange={(e: any) => {
            setCountry(e.target.value);
          }}
        />
        <TextField
          id="postalcode"
          variant="outlined"
          placeholder="Country"
          value={postalCode ?? ""}
          onChange={(e: any) => {
            setPostalCode(e.target.value);
          }}
        />
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 1 }}>
          Contact Information
        </Typography>
        <Stack
          className="form-checkbox-row form-two-col-row"
          direction="row"
          gap="30px"
          flexWrap="wrap"
        >
          <FormControlLabel
            control={
              <Switch
                checked={isPrimary}
                onChange={(e) => setIsPrimary(e.target.checked)}
              />
            }
            label="Is Primary"
          />
          <FormControlLabel
            control={
              <Switch
                checked={isPrivateInfo}
                onChange={(e) => setIsPrivateInfo(e.target.checked)}
              />
            }
            label="Is Private Info"
          />
        </Stack>
        <FormLabel component="legend">Email Contact Type</FormLabel>
        <Select
          id="emailContactType"
          value={emailContactType}
          onChange={(e) => {
            setEmailContactType(e.target.value);
            setEmailValueError(false);
            setEmailValueErrorMessage("");
          }}
          fullWidth
        >
          {VENDOR_MAIL_CONTACT_TYPES.map((type) => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))}
        </Select>
        <FormLabel component="legend">Email</FormLabel>
        <TextField
          id="emailValue"
          variant="outlined"
          placeholder="Email Address"
          value={emailValue ?? ""}
          onChange={(e: any) => {
            setEmailValue(e.target.value || null);
            setEmailValueError(false);
            setEmailValueErrorMessage("");
          }}
          error={emailValueError}
          helperText={emailValueError ? emailValueErrorMessage : ""}
        />
        <FormLabel component="legend">Phone Contact Type</FormLabel>
        <Select
          id="phoneContactType"
          value={phoneContactType}
          onChange={(e) => {
            setPhoneContactType(e.target.value);
            setPhoneValueError(false);
            setPhoneValueErrorMessage("");
          }}
          fullWidth
        >
          {VENDOR_PHONE_CONTACT_TYPES.map((type) => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))}
        </Select>
        <FormLabel component="legend">Phone</FormLabel>
        <TextField
          id="phoneValue"
          variant="outlined"
          placeholder="Phone Number"
          value={phoneValue ?? ""}
          onChange={(e: any) => {
            setPhoneValue(e.target.value || null);
            setPhoneValueError(false);
            setPhoneValueErrorMessage("");
          }}
          error={phoneValueError}
          helperText={phoneValueError ? phoneValueErrorMessage : ""}
        />
        <Stack direction="row" width="100%" justifyContent="flex-end">
          <Button
            variant="contained"
            sx={{
              cursor: "pointer",
              border: "1px solid gray",
              borderRadius: "10px",
              background: "darkgreen",
              color: "white",
            }}
            onClick={() =>
              selectedId ? updateGoldVendorSetup() : addGoldVendorSetup()
            }
          >
            {selectedId ? buttonValues.UPDATE : buttonValues.ADD}
            Vendor
          </Button>
        </Stack>
        <Stack direction="column" gap="10px" mt={4}>
          <Typography variant="body2" sx={{ color: "red", fontWeight: 800 }}>
            Do not use sample data. Those are for demo purposes only!
          </Typography>
          <Typography variant="h6">Vendors Available</Typography>
          <Stack direction="column" gap="10px">
            {GoldVendorSetup ? (
              <DraggableItemList
                itemData={GoldVendorSetup}
                onOrderUpdate={(order) => setGoldVendorSetup(order)}
                onEdit={(info) => editGoldVendorSetup(info)}
                onDelete={(id) => deleteGoldVendorSetup(id)}
                code={DNDFieldsEnum.VENDORCODE}
                name={DNDFieldsEnum.VENDORNAME}
              />
            ) : (
              <Typography variant="body2">
                No Allocation Block Information Available
              </Typography>
            )}
          </Stack>
        </Stack>
      </Paper>
      <AlertComponent
        message={alertMessage}
        type={alertType}
        alertOpen={openAlert}
        closeAlert={() => setOpenAlert(false)}
      />
    </Stack>
  );
};
export default VendorSetup;
